'use strict';
class $a5fd07fa01589658$var$Game {
    constructor(initialState){
        // eslint-disable-next-line no-console
        this.status = 'idle';
        this.score = 0;
        this.board = initialState || Array(4).fill(null).map(()=>Array(4).fill(0));
    }
    moveLeft() {
        const boardBefore = JSON.stringify(this.board);
        this.board = this.board.map((row)=>this.mergeRow(row));
        if (boardBefore !== JSON.stringify(this.board)) this.addRandomTile();
        this.checkStatus();
    }
    moveRight() {
        const boardBefore = JSON.stringify(this.board);
        this.board = this.board.map((row)=>this.mergeRow(row.reverse()).reverse());
        if (boardBefore !== JSON.stringify(this.board)) this.addRandomTile();
        this.checkStatus();
    }
    moveUp() {
        const boardBefore = JSON.stringify(this.board);
        this.board = this.transpose().map((row)=>this.mergeRow(row));
        this.board = this.transpose();
        if (boardBefore !== JSON.stringify(this.board)) this.addRandomTile();
        this.checkStatus();
    }
    moveDown() {
        const boardBefore = JSON.stringify(this.board);
        this.board = this.transpose().map((row)=>this.mergeRow(row.reverse()).reverse());
        this.board = this.transpose();
        if (boardBefore !== JSON.stringify(this.board)) this.addRandomTile();
        this.checkStatus();
    }
    getScore() {
        return this.score;
    }
    getState() {
        return this.board;
    }
    getStatus() {
        return this.status;
    }
    start() {
        this.status = 'playing';
        this.addRandomTile();
        this.addRandomTile();
    }
    restart() {
        this.board = Array(4).fill(null).map(()=>Array(4).fill(0));
        this.status = 'idle';
        this.score = 0;
    }
    addRandomTile() {
        const emptyCells = [];
        for(let row = 0; row < this.board.length; row++){
            for(let col = 0; col < this.board[row].length; col++)if (this.board[row][col] === 0) emptyCells.push([
                row,
                col
            ]);
        }
        if (emptyCells.length === 0) return;
        const randomTile = Math.floor(Math.random() * emptyCells.length);
        const [randomRow, randomCol] = emptyCells[randomTile];
        this.board[randomRow][randomCol] = Math.random() < 0.1 ? 4 : 2;
    }
    mergeRow(row) {
        const filtered = row.filter((cell)=>cell !== 0);
        for(let i = 0; i < filtered.length; i++)if (filtered[i] === filtered[i + 1]) {
            filtered[i] *= 2;
            filtered.splice(i + 1, 1);
            this.score += filtered[i];
        }
        while(filtered.length < 4)filtered.push(0);
        return filtered;
    }
    transpose() {
        return this.board[0].map((_, colIndex)=>this.board.map((row)=>row[colIndex]));
    }
    hasNoMoves() {
        for(let row = 0; row < this.board.length; row++)for(let col = 0; col < this.board[row].length; col++){
            if (row + 1 < this.board.length && this.board[row][col] === this.board[row + 1][col]) return false;
            if (this.board[row][col] === 0) return false;
            if (col + 1 < this.board[row].length && this.board[row][col] === this.board[row][col + 1]) return false;
        }
        return true;
    }
    checkStatus() {
        if (this.board.flat().some((cell)=>cell === 2048)) this.status = 'win';
        else if (this.hasNoMoves()) this.status = 'lose';
    }
}
var $a5fd07fa01589658$export$2e2bcd8739ae039 = $a5fd07fa01589658$var$Game;


'use strict';
const $09e991522ca7e64e$var$game = new (0, $a5fd07fa01589658$export$2e2bcd8739ae039)();
function $09e991522ca7e64e$var$renderBoard() {
    const cells = document.querySelectorAll('.field-cell');
    $09e991522ca7e64e$var$game.getState().flat().map((value, index)=>{
        cells[index].className = 'field-cell';
        if (value > 0) cells[index].classList.add(`field-cell--${value}`);
        cells[index].textContent = value || '';
        if (value === 2048) document.querySelector('.message.message-win').classList.remove('hidden');
        if ($09e991522ca7e64e$var$game.hasNoMoves()) document.querySelector('.message.message-lose').classList.remove('hidden');
    });
    $09e991522ca7e64e$var$renderScore();
}
const $09e991522ca7e64e$var$button = document.querySelector('.button.start');
$09e991522ca7e64e$var$button.addEventListener('click', ()=>{
    if ($09e991522ca7e64e$var$game.getStatus() === 'idle') {
        $09e991522ca7e64e$var$game.start();
        $09e991522ca7e64e$var$renderBoard();
        document.querySelector('.message.message-start').classList.add('hidden');
        $09e991522ca7e64e$var$button.classList.remove('start');
        $09e991522ca7e64e$var$button.textContent = 'Restart';
        $09e991522ca7e64e$var$button.classList.add('restart');
    } else {
        $09e991522ca7e64e$var$game.restart();
        $09e991522ca7e64e$var$renderBoard();
        document.querySelector('.message.message-start').classList.remove('hidden');
        document.querySelector('.message.message-win').classList.add('hidden');
        document.querySelector('.message.message-lose').classList.add('hidden');
        $09e991522ca7e64e$var$button.classList.remove('restart');
        $09e991522ca7e64e$var$button.classList.add('start');
        $09e991522ca7e64e$var$button.textContent = 'Start';
    }
});
document.addEventListener('keydown', (e)=>{
    if ($09e991522ca7e64e$var$game.getStatus() !== 'playing') return;
    switch(e.key){
        case 'ArrowLeft':
            $09e991522ca7e64e$var$game.moveLeft();
            break;
        case 'ArrowRight':
            $09e991522ca7e64e$var$game.moveRight();
            break;
        case 'ArrowDown':
            $09e991522ca7e64e$var$game.moveDown();
            break;
        case 'ArrowUp':
            $09e991522ca7e64e$var$game.moveUp();
            break;
    }
    $09e991522ca7e64e$var$renderBoard();
});
function $09e991522ca7e64e$var$renderScore() {
    document.querySelector('.game-score').textContent = $09e991522ca7e64e$var$game.getScore();
}


//# sourceMappingURL=js_2048_game.18de4adb.js.map
